// extracted by mini-css-extract-plugin
export var cardIcon = "_5d-4";
export var checkboxCard = "_5d-0";
export var checkboxCardSelected = "_5d-3";
export var disabled = "_5d-1";
export var outerBorder = "_5d-2";
export var spacerMedium = "_5d-7";
export var spacerSmall = "_5d-6";
export var spacerXsmall = "_5d-5";